import { getUserAuditTrail } from '@appt-digital/frontend-api-lib-sheffmed'
import React, { useContext, useEffect, useState, useCallback, useMemo } from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '../../ui-library/components/Typography'
import { useFormik } from 'formik'
import { productSchema } from '../../config/validation'
import {
  deleteAppUser,
  editAppUser,
  resetAppUser,
} from '../../handlers/requests/users/appUsersHandler'

import { editProduct } from '../../handlers/requests/sheffmed/products'

import ConfirmationModal from '../../ui-library/components/dialogs/ConfirmationModal'
import { AlertContext } from '../../context/AlertContext'
import TextField from '../../ui-library/components/TextField'
import Dropdown from '../../ui-library/components/Dropdown'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '../../ui-library/components/Button'
import Link from '../../ui-library/components/Link'

import Image from '../../ui-library/components/Image'


import { FaUser } from 'react-icons/fa'
import { MdDeleteForever } from 'react-icons/md'
import { ThemeContext } from '../../ui-library/components/ThemeContext'
import DashboardContainer from '../../ui-library/components/DashboardContainer'

import DropZone from '../../ui-library/components/DropZone'
import CreatableSelect from 'react-select/creatable';

import { uploadFile } from '../../utils/api'

import TabHeader from '../../ui-library/components/TabHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import toCapitalised from '../../utils/capitaliseString'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '../../ui-library/components/DataTable'
import uuid from 'react-uuid'

import {useDropzone} from 'react-dropzone';
import color from '../../ui-library/styles/color'


function EditProduct() {
  const [loading, setLoading] = useState(false)
  const { setAlert } = useContext(AlertContext)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [variations, setVariations] = useState([])
  const [audit, setAudit] = useState([])
  const { theme } = useContext(ThemeContext)
  const { state } = useLocation()
  const navigate = useNavigate()
  const initialEdit = {
    title: state?.product?.title || '',
    summary: state?.product?.summary || '',
    description: state?.product?.description || '',
    featured: state?.product?.featured || false,
    units: state?.product?.units || '',
    priceTierOne: state?.product?.priceTierOne || 0,
    priceTierTwo: state?.product?.priceTierTwo || 0,
    priceTierThree: state?.product?.priceTierThree || 0,
    priceDefault: state?.product?.priceDefault || 0
  }

  const [imageUploading, setImageUploading] = useState(false)

  const [imagePreviewUrl, setImagePreviewUrl] = useState(null)
  const [imageUrl, setImageUrl] = useState(null)

  const [productCodes, setProductCodes] = useState({})

  useEffect(() => {
    if (state?.product?.variations && state?.product?.variations.length > 0) {
      const formattedVariations = state?.product?.variations.map((variation) => ({
        label: variation,
        value: variation,
      }))
      setVariations(formattedVariations)
    } else {
      setVariations([])
    }
  }, [state?.product?.variations])

  useEffect(() => {
    if (state?.product?.codes && state?.product?.codes.length > 0) {
      const formattedCodes = {}
      if (state?.product?.variations?.length) {
        state?.product?.codes?.forEach((code, index) => {
          formattedCodes[state?.product?.variations[index]] = code
        })
        setProductCodes(formattedCodes)
      }
    } else {
      setProductCodes({})
    }   
  }, [state?.product?.codes, state?.product?.variations])


   const [featured, setFeatured] = useState(
        {
          label: state?.product?.featured ? 'Yes' : 'No',
          value: state?.product?.featured,
        } || { label: 'No', value: false }
      )
    

  const [productImage, setProductImage] = useState()

  useEffect(() => {
    setImagePreviewUrl(state?.product?.featuredImageUrlSigned)
    setImageUrl(state?.product?.featuredImageUrl)
    // setProductImage(state?.product?.record?.signedUrl)
  }, [])


  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialEdit,
      validationSchema: productSchema,
      onSubmit: async () => await handleEdit(),
    })
  const handleEdit = async () => {


    values.featured = featured.value
    values.variations = variations.map((variation) => variation.value)

    // get the product codes for each variation
    values.codes = variations.map((variation) => {
      return productCodes[variation.value] || ''
    })
  
    if (imageUrl) {
      values.featuredImageUrl = imageUrl 
    }

    // console.log('editProduct', state?.product?.id, values)

    await editProduct(
      state?.product?.id,
      values
    )

    // return

    // setAlert,
    setLoading(false)
    navigate('/dashboard/products')
  }



  const components = {
    DropdownIndicator: null,
  };

  const createOption = (label) => ({
    label,
    value: label,
  });



  const [inputValue, setInputValue] = React.useState('');
  const [value, setValue] = React.useState([]);

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setVariations((prev) => [...prev, createOption(inputValue)]);
        setInputValue('');
        event.preventDefault();
    }
  };


  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files

    console.log("acceptedFiles", acceptedFiles)

    const processFile = async (file) => {
      setImageUploading(true)
      setImagePreviewUrl(null)
  

      // get the base64 data of the file
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        const data = reader.result.split(',')[1] // get the base64 data without the prefix
        // console.log('data', data)
       
        let results = await uploadFile(file.name, file.type, data)

        console.log("results", results)
        setImageUrl(results.url)

        if (results?.signedUrl) {
          setImagePreviewUrl(results?.signedUrl)
        }
        

        setImageUploading(false)

        
      }
      

    }
    processFile(acceptedFiles[0])

  

    // timeout after 15 seconds to stop the upload
    setTimeout(()=>{ setImageUploading(false) }, 15000)


    
  }, [])




  const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 1,
  borderRadius: 5,
  borderColor: color.primary,
  borderStyle: 'solid',
  backgroundColor: '#fafafa',
  color: color.primary3,
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

function StyledDropzone(props) {
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    
    onDrop,
    accept: {
      'image/*': []
    },
    maxFiles: 1
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);


  // const files = acceptedFiles.map(file => (
  //   <li key={file.path}>
  //     {file.path} - {file.size} bytes
  //   </li>
  // ));

  return (
    <div className="container">
      <div {...getRootProps({style})}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      
    </div>
  );
}

  

  return (
    <>
      <DashboardContainer>
        <TabHeader
          title={'Edit Product'}
          username={
            state?.user?.firstname !== null &&
            state?.user?.firstname !== undefined &&
            state?.user?.lastname !== null &&
            state?.user?.lastname !== undefined &&
            `${toCapitalised(state?.user?.firstname)} ${toCapitalised(
              state?.user?.lastname
            )}`
          }
        >
          <Paper style={theme?.dashboard?.container}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div>
                <Link
                  type="submit"
                  onClick={() => {
                    navigate('/dashboard/products')
                  }}
                >
                  {`< Back`}
                </Link>
                <Typography source={'h1'} style={{ marginTop: 20 }}>Product Details</Typography>

                <form onSubmit={handleSubmit}>

      
                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Title</Typography>
                    <TextField
                      type="title"
                      name="title"
                      placeholder="Title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'title'}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Summary</Typography>
                    <TextField
                        type="summary"
                        name="summary"
                        placeholder="Summary"
                        value={values.summary}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'summary'}
                        errors={errors}
                        touched={touched}
                      />
                  </div>
                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Description</Typography>
                    <TextField
                      type="description"
                      name="description"
                      placeholder="Description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'description'}
                      errors={errors}
                      touched={touched}
                      multiline
                      style={{ height: '100%' }}
                      // minRows={4}
                    />
                  </div>

                   <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Variations (optional)</Typography>

                      <CreatableSelect
                        components={components}
                        inputValue={inputValue}
                        isClearable
                        isMulti
                        backspaceRemovesValue
                        menuIsOpen={false}
                        onChange={(newValue) => setVariations(newValue)}
                        onInputChange={(newValue) => setInputValue(newValue)}
                        onKeyDown={handleKeyDown}
                        placeholder="Leave blank, or type something and press enter..."
                        value={variations}
                      />
                    </div>

 
                    

                    {variations?.length > 0 && (
                      variations?.map((variation, index) => {
                        return (
                          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20 }}>
                            <Typography source={'h5'} style={{ marginTop: 10 }}>{variation.label} Product Code</Typography>


                            <TextField
                              type="text"
                              name="summary"
                              placeholder="Product Code"
                              value={productCodes[variation.value] || ''}
                              onChange={(e) => {
                                setProductCodes({
                                  ...productCodes,
                                  [variation.value]: e.target.value,
                                })
                              }}
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              errorType={'summary'}
                              errors={errors}
                              touched={touched}
                            />
                          </div> 

                        )
                      })
                    )}

                  <div style={{ display: 'flex', flexDirection: 'column' }} >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Units</Typography>
                    <TextField
                      name="units"
                      value={values.units}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'units'}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                      
                   <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Featured</Typography>
                      <Dropdown
                        type="featured"
                        id={'featured'}
                        name={'featured'}
                        setSelected={setFeatured}
                        onBlur={handleBlur}
                        selected={featured}
                         clearable={true}
                        items={[
                          { label: 'No', value: false },
                          { label: 'Yes', value: true }
                        ]}
                        Icon={ArrowDropDownIcon}
                        errorType={'type'}
                        errors={errors}
                        touched={touched}
                        style={{ container: { width: '100%', marginBottom: 5, background: '#fff' } }}
                      />
                    </div>


                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <Box>
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Product Image</Typography>
                    </Box>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                      {imagePreviewUrl && <Image image={imagePreviewUrl} />}
                      {/* <DropZone 
                      
                        setFile={(file) => {
                          console.log('file', file)
                          // setProductImage(file)
                          // return file
                        }}
                      /> */}
                      {!imageUploading && <StyledDropzone />}
                      {imageUploading && (
                        <Typography source={'p'}>Uploading...</Typography>
                      )}
                          {/* <section className="container">
                              <div {...getRootProps({className: 'dropzone'})}>
                                <input {...getInputProps()} />
                                <p>Drag 'n' drop some files here, or click to select files</p>
                              </div>
                              <aside>
                                <h4>Files</h4>
                                <ul>{files}</ul>
                              </aside>
                            </section> */}

                    </div>
                  </div>
                  
                  <hr />
                  <div
                    style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}
                  >

                   

                    <Typography source={'h3'} style={{ marginTop: 10 }}>Pricing</Typography>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Default Price</Typography>
                      <Typography source={'p'} style={{ marginTop: 0, fontSize: 12 }}>[REQUEST A QUOTE]</Typography>
                    </div>


                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Price - Tier One</Typography>
                      <TextField
                        type="number"
                        name="priceTierOne"
                        placeholder="£"
                        value={values.priceTierOne}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'priceTierOne'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Price - Tier Two</Typography>
                      <TextField
                        type="number"
                        name="priceTierTwo"
                        placeholder="£"
                        value={values.priceTierTwo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'priceTierTwo'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Typography source={'h4'} style={{ marginTop: 10 }}>Price - Tier Three</Typography>

                      <TextField
                        type="number"
                        name="priceTierThree"
                        placeholder="£"
                        value={values.priceTierThree}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'priceTierThree'}
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                  </div>
                
                  <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                    <Button type="submit" primary>Save</Button>
                    <Button variant='primary'
                      onClick={() => {
                        setConfirmDelete(true)
                      }}
                      icon={MdDeleteForever}
                      icontype={'endIcon'}
                    >
                      Delete Product
                    </Button>
                  </div>
                </form>
                <ConfirmationModal
                  onAccept={async () => {
                    // await deleteAppUser(state?.user?.id, setAlert)

                     await editProduct(state?.product?.id,{
                      deletedAt: new Date().toISOString(),      
                    })

                    navigate('/dashboard/products')
                  }}
                  isOpen={confirmDelete}
                  onRequestClose={() => setConfirmDelete(false)}
                  type={'Delete'}
                  text={'Are you sure you wish to delete this product?'}
                  icon={MdDeleteForever}
                />
              
              </div>
              {/* <div
                style={{
                  margin: 20,
                  borderLeft: '1px solid grey',
                  minHeight: 600,
                }}
              /> */}
              {/* <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                <Typography source={'h2'} style={{ marginTop: 30 }}>
                  Audit Trail
                </Typography>
                {!audit?.length || audit?.length < 1 ? (
                  <Typography source={'p'} style={{ marginTop: 10 }}>
                    No audit trail found
                  </Typography>
                ) : (
                  <TableContainer source={'audit'} theme={theme}>
                    <Table source={'audit'} theme={theme}>
                      <TableHead source={'audit'} theme={theme}>
                        {['Time', 'Action']?.map((header, index) => {
                          return (
                            <TableCell
                              source={'audit'}
                              key={uuid()}
                              theme={theme}
                            >
                              <Typography>{header}</Typography>
                            </TableCell>
                          )
                        })}
                      </TableHead>
                      {audit?.map((item) => {
                        return (
                          <TableRow source={'audit'} theme={theme} key={uuid()}>
                            <TableCell source={'audit'} theme={theme}>
                              {new Date(item?.updatedAt).toLocaleString()}
                            </TableCell>
                            <TableCell source={'audit'} theme={theme}>
                              {item?.description}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </Table>
                  </TableContainer>
                )}
              </div> */}
            </div>
          </Paper>
        </TabHeader>
      </DashboardContainer>
    </>
  )
}

export default EditProduct
